require('./boolean.html');
require('./checkbox.html');
require('./date.html');
require('./download.html');
require('./dropdown_multiple_select.html');
require('./dropdown_single_select.html');
require('./euro_betrag.html');
require('./radio_buttons.html');
require('./single_checkbox.html');
require('./string.html');
require('./string_ajax_autocomplete.html');
require('./textarea.html');
require('./time.html');
require('./two_list_select.html');
